var ko = require('knockout'),
  APIHelper = require('_js/APIHelper'),
  $ = require('jquery');

function AdminToolUserManagement(params) {
  this.API = params.api;
  this.title = params.texts.title;
}

AdminToolUserManagement.prototype.init = function(element) {
  this.$element = $(element);
  this.aktorID = ko.observable('');
  this.aktorIDError = ko.observable('');

  this.isLoading = ko.observable(false);
  this.showResetPasswordBtn = ko.observable(false);

  this.showResultInRed = ko.observable(false);
  this.hasResult = ko.observable(false);
  this.result = {
    message: ko.observable(),
    username: ko.observable(),
    password: ko.observable()
  };

  this.unlockUserMessage = ko.observable('');
  this.userUnlocked = ko.observable(true);
};

AdminToolUserManagement.prototype.validateNumber = function() {
  var self = this;

  self.hasResult(false);
  self.showResetPasswordBtn(false);

  var onlyNumbers = /^\d+$/.test(self.aktorID());

  if (self.aktorID().length == 8 && onlyNumbers) {
    self.aktorIDError('');
    self.createEpiUser();
  } else if (!onlyNumbers && self.aktorID() !== '') {
    self.aktorIDError("ID'en kan bare inneholde tall");
  } else if (self.aktorID().length < 8) {
    self.aktorIDError("ID'en trenger 8 siffer");
  } else {
    self.aktorIDError("ID'en kan ikke ha mer enn 8 siffer");
  }
};

AdminToolUserManagement.prototype.hideResetPasswordBtnOnChange = function(
  data,
  event
) {
  var self = this;
  if (event.which == 13) {
    self.sendAPICall();
  } else {
    self.showResetPasswordBtn(false);
    self.hasResult(false);
  }
  return true;
};

AdminToolUserManagement.prototype.createEpiUser = function() {
  var self = this;

  self.isLoading(true);
  var url = self.API.createEpiUserFromCRMUserUrl + '/' + self.aktorID();

  APIHelper.post(
    url,
    {},
    function(response) {
      self.result.message(
        response.Message
          ? response.Message
          : 'Noe gikk galt. Vennligst prøv igjen.'
      );
      if (response.Result == 0) {
        self.result.username(response.Username);
        self.result.password(response.GeneratedPassword);
        self.showResultInRed(false);
        self.showResetPasswordBtn(false);
        self.reset();
      } else if (response.Result == 1) {
        self.showResultInRed(true);
        self.showResetPasswordBtn(true);
        self.userUnlocked(!response.IsLocked);
      } else {
        self.showResultInRed(true);
        self.showResetPasswordBtn(false);
      }
      self.hasResult(true);
      self.isLoading(false);
    },
    function(error) {
      self.serverresult.messageError(JSON.stringify(error, null, 4));
    }
  );
};

AdminToolUserManagement.prototype.resetPassword = function() {
  var self = this;
  self.hasResult(false);
  self.isLoading(true);

  var url = self.API.resetPassword + '/' + self.aktorID();

  APIHelper.post(
    url,
    {},
    function(response) {
      self.result.message(
        response.Message
          ? response.Message
          : 'Noe gikk galt. Vennligst prøv igjen.'
      );
      if (response.Result === 0) {
        self.result.username(response.Username);
        self.result.password(response.GeneratedPassword);
        self.showResultInRed(false);
        self.reset();
      } else {
        self.showResultInRed(true);
      }
      self.showResetPasswordBtn(false);
      self.hasResult(true);
      self.userUnlocked(true);
      self.isLoading(false);
    },
    function(error) {
      self.result.message(JSON.stringify(error, null, 4));
    }
  );
};

AdminToolUserManagement.prototype.reset = function() {
  this.aktorIDError('');
  this.isLoading(false);
  this.showResetPasswordBtn(false);
  this.aktorID('');
};

AdminToolUserManagement.prototype.sendAPICall = function() {
  var self = this;
  if (self.showResetPasswordBtn()) {
    // reset password
    self.resetPassword();
  } else {
    // create epi user
    self.validateNumber();
  }
};

AdminToolUserManagement.prototype.unlockUser = function() {
  var self = this;
  var url = self.API.unlockUserUrl + '/' + self.aktorID();
  APIHelper.post(
    url,
    {},
    function(response) {
      if (response.IsSuccess) {
        self.userUnlocked(true);
        self.unlockUserMessage('Brukeren ble låst opp');
      } else {
        self.unlockUserMessage(response.ErrorMessage);
        self.userUnlocked(false);
      }
    },
    function(error) {
      self.result.message(JSON.stringify(error, null, 4));
    }
  );
};

module.exports = AdminToolUserManagement;
